import Enum from "../Enum";

export default Enum.create( {
	PRIMARY: "PRIMARY",
	SECONDARY: "SECONDARY",
	TERTIARY: "TERTIARY",
	QUATERNARY: "QUATERNARY",
} );
